import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { useAuthStore } from "@/client/stores/auth";

export const AuthGuard = () => {
  const { user, loading, fetchUser } = useAuthStore();

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    fetchUser();
  }, []);

  // eslint-disable-next-line lingui/no-unlocalized-strings
  if (loading) return <div>Loading...</div>;

  if (user) {
    return <Outlet />;
  }

  return <Navigate replace to={`/`} />;
};
